import React, { Component } from 'react'
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup } from 'reactstrap'
import CreatableSelect from '../../../Wps/CreatableSelect'

class WeldTypeModal extends Component {
  constructor(props) {
    super(props)
    
    // Konwertuj obecną wartość na array dla multiselect
    const currentValue = props.weldData && props.weldData.weld_type && Array.isArray(props.weldData.weld_type) ? 
      props.weldData.weld_type.map(wjt => {
        const weldTypeName = wjt.weld_type ? wjt.weld_type.name : 'Unknown'
        const jointTypeName = wjt.joint_type ? wjt.joint_type.name : null
        const combinedValue = `${wjt.weld_type ? wjt.weld_type.id : ''}-${wjt.joint_type ? wjt.joint_type.id : ''}`
        const displayName = jointTypeName ? `${weldTypeName}-${jointTypeName}` : weldTypeName
        return { value: combinedValue, name: displayName }
      }) : []
    
    this.state = {
      selectedWeldTypes: currentValue
    }
  }

  handleChange = (selectedOptions) => {
    this.setState({ selectedWeldTypes: selectedOptions || [] })
  }

  handleSubmit = () => {
    const weldJointTypes = this.state.selectedWeldTypes.map(opt => {
      const [weld_type_id, joint_type_id] = opt.value.split('-')
      return {
        weld_type_id: Number(weld_type_id),
        joint_type_id: joint_type_id ? Number(joint_type_id) : null
      }
    })
    this.props.onSubmit(weldJointTypes, this.props.selectedWelds || [this.props.weldData])
  }

  render() {
    const options = this.props.weldTypeDict.map(opt => ({
      value: opt.value,
      name: opt.text
    }))

    return (
      <Modal isOpen={true} toggle={this.props.onCancel}>
        <ModalHeader toggle={this.props.onCancel}>
          Select Weld Types
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={(e) => { e.preventDefault(); this.handleSubmit(); }}>
            <CreatableSelect
              options={options}
              valueKey="value"
              value={this.state.selectedWeldTypes}
              multi={true}
              creatable={false}
              valueChangeFunction={this.handleChange}
              placeholder="Select weld types..."
            />
            <FormGroup>
              <hr/>
              <Button className="float-right" color="secondary" onClick={this.props.onCancel}>
                Cancel
              </Button>
              <Button className="float-right" color="primary" type="submit">
                Save
              </Button>
            </FormGroup>
          </Form>
        </ModalBody>
      </Modal>
    )
  }
}

export default WeldTypeModal


// WEBPACK FOOTER //
// ./src/components/Welds/helpers/wps/WeldTypeModal.js